import { render, staticRenderFns } from "./NursingPlanEdit.vue?vue&type=template&id=11fbae12&scoped=true&"
import script from "./NursingPlanEdit.vue?vue&type=script&lang=ts&"
export * from "./NursingPlanEdit.vue?vue&type=script&lang=ts&"
import style0 from "./NursingPlanEdit.vue?vue&type=style&index=0&id=11fbae12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fbae12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
